module.exports = __webpack_public_path__ + "static/media/Take Up Rollers 11.b6b80f42.jpg";